/*
 *  DIGITALX LABS(PVT)LTD PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * 
 *  Copyright © 2019. DIGITALX LABS(PVT)LTD
 *  All Rights Reserved.
 */

import React, { Component } from 'react';
import { Container, Row, Col, Form, FormGroup } from 'reactstrap';
import Toast from '../common/custom-controls/Toast';
import SmsSubscription from './SmsSubscription';
import PackageSummary from './PackageSummary';
import SubscriptionLog from './SubscriptionLog';
import CustomSubscriptionByMobile from './CustomizeSubscription';
import { subscriberService } from '../../services/subscriber-service';
import SimpleReactValidator from 'simple-react-validator';

class AllSubscribers extends Component {

    constructor(props) {
        super(props);
        this.validator = new SimpleReactValidator({
            autoForceUpdate: this
        });

        this.state = {
            toast: {
                type: '',
                message: ''
            }
        };
    }

    handleToastClose = (status) => {
        if (!status) {
            this.setState({
                toast: { type: '', message: '' }
            });
        }
    };

    handleOnSearch = (toast) => {
        if (toast?.message) {
            this.setState({ toast });
        }
    };

    render() {
        const { toast } = this.state;

        return (
            <Container fluid>
                <Toast
                    handleOnClose={this.handleToastClose}
                    isOpen={!!toast.message}
                    type={toast.type}
                    message={toast.message}
                />

                <Row>
                    <Col md={8}>
                        <h4>Subscribers</h4>
                    </Col>
                </Row>

                <Row>
                    <Col md={12}>
                        <div className="border bg-white shadow-sm mt-2" style={{ borderRadius: '.5rem' }}>
                            <div className="classic-tabs">
                                <ul
                                    className="nav tabs-primary border-bottom"
                                    id="myClassicTab"
                                    role="tablist"
                                    style={{ fontSize: '15px', padding: '5px' }}
                                >
                                    <li className="nav-item">
                                        <a
                                            className="nav-link active show text-muted"
                                            data-toggle="tab"
                                            href="#package-summary"
                                        >
                                            Package Summary
                                        </a>
                                    </li>

                                    <li className="nav-item">
                                        <a
                                            className="nav-link text-muted"
                                            data-toggle="tab"
                                            href="#subscribers-log"
                                        >
                                            Subscribers Log
                                        </a>
                                    </li>

                                    <li className="nav-item">
                                        <a
                                            className="nav-link text-muted"
                                            data-toggle="tab"
                                            href="#unsubscribe"
                                        >
                                            Subscribe
                                        </a>
                                    </li>

                                    
                                    <li className="nav-item">
                                        <a
                                            className="nav-link text-muted"
                                            data-toggle="tab"
                                            href="#custom-subscribe"
                                        >
                                            Customize Subscribe
                                        </a>
                                    </li>
                                </ul>

                                <div className="tab-content" id="myClassicTabContent">

                                    <div className="tab-pane fade active show" id="package-summary">
                                        <PackageSummary onSearch={this.handleOnSearch} />
                                    </div>

                                    <div className="tab-pane fade" id="subscribers-log">
                                        <SubscriptionLog onSearch={this.handleOnSearch} />
                                    </div>

                                    <div className="tab-pane fade" id="unsubscribe">
                                        <SmsSubscription />
                                    </div>

                                    <div className="tab-pane fade" id="custom-subscribe">
                                        <div className="p-3">
                                            <CustomSubscriptionByMobile
                                                packageId={67}
                                                onClose={(data) => {
                                                    if (data?.message) {
                                                        this.setState({
                                                            toast: {
                                                                type: 'success',
                                                                message: data.message
                                                            }
                                                        });
                                                    }
                                                }}
                                            />
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        );
    }
}

export default AllSubscribers;
